import React, { useState, useEffect } from 'react';
import { FEEDBACK } from "@hasbro/tpi-data-models";
import LikeButton from "@/components/common/buttons/LikeButton";
import DislikeButton from "@/components/common/buttons/DislikeButton";
import { STORAGE_KEY } from "@/lib/utils";

const PlaylistFeedback = ({color='#1D2142', onFeedback, playlist }) => {
    const [feedbackOption, setFeedbackOption] = useState(null); // This needs to determine if specific user given feedback...
    const uid = localStorage.getItem(STORAGE_KEY);

    useEffect(() => {
		if(uid && typeof playlist.feedback === 'object' && playlist.feedback !== null) {
			// check if user has given feedback
			Object.keys(playlist.feedback).forEach(key => {
				if (playlist.feedback[key]?.users?.includes(uid)) {
					setFeedbackOption(key);
				}
			})
		}
	}, [uid, onFeedback])


	const onLike = () => {
		onFeedback(playlist._id, FEEDBACK.liked)
		setFeedbackOption(FEEDBACK.liked)
	}
	const onDislike = () => {
		// prompt negative feedback
		onFeedback(playlist._id, FEEDBACK.other)
		setFeedbackOption(FEEDBACK.other)
	}
	return <div className={'flex gap-2 items-center relative'} style={{color}}>
		<div className={'grow tracking-wider text-base md:text-lg xl:text-xl font-gSemi'}>Did you like this playlist?</div>
		<LikeButton selected={feedbackOption && feedbackOption === FEEDBACK.liked} onClick={onLike} color={color} />
		<DislikeButton selected={feedbackOption && feedbackOption !== FEEDBACK.liked} onClick={onDislike} color={color} />
	</div>
}

export default PlaylistFeedback;
